import bsCollapse from 'bootstrap/js/dist/collapse';

export default {
  install: (app, options) => {
    const collapses = [];

    const show = (id, options = { toggle: false }, callback_route) => {
      // const collapseBtns = document.querySelectorAll('[data-bs-toggle-controls]');

      // collapseBtns.forEach(controller => {
      //   controller.classList.add('collapsed');
      // });

      const collapseEl = document.querySelectorAll(`[data-collapse=${id}]`)[0];
      const collapseIndex = collapses.findIndex(element => element.id == id);

      if (collapseIndex === -1) {
        const collapseObject = new bsCollapse(collapseEl, options);

        collapses.push({
          'id': id,
          'object': collapseObject
        });

        collapseObject.show();
      } else {
        collapses[collapseIndex].object.show();
      }

      // if (collapseBtns) {
      //   document.querySelector(`[data-bs-toggle-controls=${id}]`).classList.remove('collapsed');
      // }
    };

    const hide = id => {
      const collapseIndex = collapses.findIndex(element => element.id == id);
      collapses[collapseIndex].object.hide();
    }

    const collapse = { show, hide, collapses };
    app.config.globalProperties.$collapse = collapse;
    app.provide('$collapse', collapse);
  }
}